<!--  基站信息修改页面  -->
<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        基站信息修改
        <small>基站信息修改</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> 基站信息修改
          </a>
        </li>
        <li class="active">基站信息修改</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="col-sm-12">
        <div id="atptoolbar"></div>

        <!--  申请表单  -->
        <div class="apply-form">
          <!-- modal-body-->
          <div class="modal-body">

            <div class="panel-body">

              <div class="form-group">

                <label class="control-sidebar-subheading col-sm-6">
                  请选择基站
                  <select class="form-control" v-model="selectedStationID" @change="chooseStation(selectedStationID)">
                    <option v-for="(item,index) in stationList" :key="index" :value="item.stst_atpid">
                      {{item.stst_commname}}
                    </option>
                  </select>

                </label>

                <label class="control-sidebar-subheading col-sm-6">
                  项目名称
                  <input type="text" class="form-control" v-model="form.项目名称"/>
                </label>

              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  运营商
                  <select class="form-control" v-model="form.运营商">
                    <option value="">请选择运营商</option>
                    <option value="中国移动">中国移动</option>
                    <option value="中国联通">中国联通</option>
                    <option value="中国电信">中国电信</option>
                    <option value="中国铁塔">中国铁塔</option>
                  </select>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  分管运营商
                  <input type="text" class="form-control" v-model="form.分管运营商" disabled/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  行政分区
                  <input type="text" class="form-control" v-model="form.行政分区"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  基站位置
                  <input type="text" class="form-control" v-model="form.基站位置"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  基站形式
                  <select class="form-control" v-model="form.基站形式">
                    <option value="">请选择基站形式</option>
                    <option value="楼站">楼站</option>
                    <option value="塔站">塔站</option>
                  </select>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  塔高
                  <input type="number" class="form-control" v-model="form.塔高"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  业主电费单价
                  <input type="number" class="form-control" v-model="form.业主电费单价"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  局方电费单价
                  <input type="number" class="form-control" v-model="form.局方电费单价"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  基站经度(火星坐标)
                  <input type="number" class="form-control" v-model="form.基站经度"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  基站纬度(火星坐标)
                  <input type="number" class="form-control" v-model="form.基站纬度"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  局方合同乙方
                  <input type="text" class="form-control" v-model="form.局方合同乙方"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  业主合同甲方
                  <input type="text" class="form-control" v-model="form.业主合同甲方"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  局方合同起始日期
                  <input
                    id="局方合同起始日期"
                    name="局方合同起始日期"
                    type="text"
                    v-model="form.局方合同起始日期"
                    class="form-control field"
                    @click="datePicker('局方合同起始日期')"
                  />
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  局方合同终止日期
                  <input
                    id="局方合同终止日期"
                    name="局方合同终止日期"
                    type="text"
                    v-model="form.局方合同终止日期"
                    class="form-control field"
                    @click="datePicker('局方合同终止日期')"
                  />
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  业主合同起始日期
                  <input
                    id="业主合同起始日期"
                    name="业主合同起始日期"
                    type="text"
                    v-model="form.业主合同起始日期"
                    class="form-control field"
                    @click="datePicker('业主合同起始日期')"
                  />
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  业主合同终止日期
                  <input
                    id="业主合同终止日期"
                    name="业主合同终止日期"
                    type="text"
                    v-model="form.业主合同终止日期"
                    class="form-control field"
                    @click="datePicker('业主合同终止日期')"
                  />
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  业主姓名
                  <input type="text" class="form-control" v-model="form.业主姓名"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  业主电话
                  <input type="number" class="form-control" v-model="form.业主电话"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  业主收电费开户行
                  <input type="text" class="form-control" v-model="form.业主收电费开户行"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  业主收电费账户名称
                  <input type="text" class="form-control" v-model="form.业主收电费账户名称"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  业主收电费账号
                  <input type="text" class="form-control" v-model="form.业主收电费账号"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  电源方式
                  <input type="text" class="form-control" v-model="form.电源方式"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  备注
                  <input type="text" class="form-control" v-model="form.备注"
                         placeholder=""/>
                </label>
              </div>

            </div>

          </div>
          <!-- modal-footer -->
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
            <button type="button" class="btn btn-primary" @click="submit">确定</button>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>

  import {datepicker} from 'eonasdan-bootstrap-datetimepicker'

  export default {
    name: 'applyStationAmend',
    data() {
      return {
        stationList: [], // 基站列表
        selectedStationID: null, // 当前选中基站ID
        form: {} // 基站信息
      }
    },

    components: {datepicker},

    mounted: function () {
      let self = this
      let org_id = JSON.parse(localStorage.getItem('companyInfo')).id
      self.org_id = org_id
      console.log('___页面挂载成功,org_id:', org_id)

      // 获取公司下基站列表
      self.global.axiosGet(self, `stations/?org_id=${org_id}&per_page=999999`, function (res) {
        console.log('___获取到基站列表', res)
        self.stationList = res.rows
      })
    },

    methods: {
      chooseStation: function (value) {
        let self = this
        console.log('___切换基站', value, '开始获取基站信息')
        // 获取基站信息
        self.global.axiosGet(self, `station/${value}/`, function (res) {
          self.form = {
            '基站ID': res.stst_atpid,
            '项目名称': res.stst_commname,
            '运营商': res.stst_comm,
            '分管运营商': res.stst_subcomm,
            '基站位置': res.stst_address,
            '行政分区': res.stst_area,
            '基站形式': res.stst_type,
            '塔高': res.stst_height,
            '业主电费单价': res.stst_ownerelectricity,
            '局方电费单价': res.stst_commelectricity,
            '代谈公司': res.stst_proxytalksid,
            '基站经度': res.stst_longitude,
            '基站纬度': res.stst_latitude,
            '局方合同乙方': res.stst_commcontractpartyb,
            '业主合同甲方': res.stst_ownercontractpartya,
            '局方合同起始日期': res.stst_commcontractstar,
            '局方合同终止日期': res.stst_commcontractend,
            '业主合同起始日期': res.stst_ownercontractstar,
            '业主合同终止日期': res.stst_ownercontractend,
            '业主姓名': res.stst_ownerbossname,
            '业主电话': res.stst_ownerbossphone,
            '业主收电费开户行': res.stst_ownerbank,
            '业主收电费账户名称': res.stst_ownerbankname,
            '业主收电费账号': res.stst_ownerbankaccount,
            '电源方式': res.stst_acmode,
            '备注': res.stst_remarks
          }
          console.log('___获取到基站信息', res, '转换后', self.form)
        })
      },

      submit: function () { // 发起基站信息修改
        let self = this
        const company = localStorage.getItem('companyInfo')
        let checkPass = true
        if (!self.form.项目名称 || !self.form.运营商 || !self.form.基站位置)
          checkPass = false
        if (!checkPass) {
          alert('请将申请单填写完毕')
          return
        }

        const formData = {
          '公司ID': JSON.parse(company).id,
          ...self.form
        }

        // self.global.axiosPost(self, 'apply/5/', formData).then(res => {
        //   console.log('/apply/5/', res)
        //   if (res.status === 'success') {
        //     alert('提交成功')
        //   }
        // }).cache(res => {
        //   alert('提交失败')
        // })

        self.global.axiosPost(self,
          'apply/5/',
          formData,
          function (res) {
            console.log('/apply/5/', res)
            if (res.status === 'success') {
              alert('提交成功')
            }
          },
          function (response) {
            console.log('___提交失败')
            response.response && response.response.data.message && alert(response.response.data.message)
          }
        )

      },

      datePicker: function (elementId) {
        let self = this
        WdatePicker({
          el: elementId,
          dateFmt: 'yyyy-MM-dd HH:mm:ss', //日期格式，可以只显示年或年月，也可以额外显示时间
          onpicked: function () {
            var value = $('#' + elementId).val()
            console.log('___日期elementId', elementId, value)
            // var timeStamp = self.global.timeToStamp(value)
            self.form[elementId] = value
          },
          oncleared: function () {
            self[elementId] = null
          },
          isShowClear: true,
          readOnly: true
        })
      },

    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/applyWorkflow/applyStationAmend.vue